import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  statisticEmail: null,
  dataContentEmail: "",
});

let result = "";

const reportEmail = (state = defaultState, action) => {
  switch (action.type) {
    case types.GET_STATISTIC_EMAIL_RESULT:
      result = action.payload;
      return state.set("statisticEmail", result);

    case types.GET_CONTENT_LOG_EMAIL_RESULT:
      result = action.payload;
      return state.set("dataContentEmail", result);

    default:
      return state;
  }
};

export default reportEmail;
